// Share only in-flight page reads. Never cache completed financial data or
// intercept the fresh reads performed by mutation actions.
const owners = new WeakMap()

export function contractReadFlight(owner, id, read) {
  let pending = owners.get(owner)
  if (!pending) {
    pending = new Map()
    owners.set(owner, pending)
  }
  if (pending.has(id)) return pending.get(id)
  const promise = Promise.resolve().then(read).finally(() => pending.delete(id))
  pending.set(id, promise)
  return promise
}
